module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-acebe96272468e12647646c118e3593d.png";